module.exports = __webpack_public_path__ + "img/2.1280603c.png";